import { StandardEvents } from '@shopify/events';

class CotigoArticleFloat extends HTMLElement {
  connectedCallback() {
    this.panels = [...this.querySelectorAll('[data-float-panel]')];
    this.body = document.getElementById(this.dataset.readingSection)?.querySelector('[data-cotigo-editor-content]');
    if (!this.panels.length || !this.body) return;
    this.abort = new AbortController();
    const { signal } = this.abort;
    this.current = 0;this.elapsed = 0;this.last = performance.now();this.armed = false;this.pending = false;
    this.storageKey = `cotigo.articleRecommendation.closed.v2:${location.pathname.replace(/\/+$/, '')}`;
    try { this.dismissed = sessionStorage.getItem(this.storageKey) === '1'; } catch (_) { this.dismissed = false; }
    this.querySelector('[data-float-close]').addEventListener('click', () => this.dismiss(), { signal });
    this.querySelectorAll('[data-float-step]').forEach(button => button.addEventListener('click', () => this.select(Number(button.dataset.floatStep)), { signal }));
    this.addEventListener('keydown', event => { if (event.key === 'Escape') {event.preventDefault();this.dismiss();} }, { signal });
    this.addEventListener('submit', event => {
      if (this.pending) {event.preventDefault();event.stopImmediatePropagation();return;}
      this.pending = true;
      this.panels[this.current].querySelector('[data-float-status]').textContent = this.dataset.adding;
    }, { capture: true, signal });
    document.addEventListener(StandardEvents.cartLinesUpdate, event => this.cartUpdate(event), { signal });
    document.addEventListener('visibilitychange', () => {this.last = performance.now();}, { signal });
    window.addEventListener('scroll', () => this.tick(), { passive: true, signal });
    this.timer = window.setInterval(() => this.tick(), 500);
    if (this.dataset.previewMode === 'true' && new URLSearchParams(location.search).get('cotigo_article_float_preview') === 'show') {
      this.armed = true;this.dismissed = false;
    }
    this.tick();
  }

  disconnectedCallback() {
    this.abort?.abort();clearInterval(this.timer);
  }

  select(step) {
    if (this.pending) return;
    this.panels[this.current].hidden = true;
    this.current = (this.current + step + this.panels.length) % this.panels.length;
    const panel = this.panels[this.current];panel.hidden = false;
    panel.querySelectorAll('img[loading="lazy"]').forEach(image => image.loading = 'eager');
    const count = this.querySelector('.article-float__count');
    if (count) count.textContent = `${this.current + 1} / ${this.panels.length}`;
  }

  dismiss() {
    this.dismissed = true;
    try { sessionStorage.setItem(this.storageKey, '1'); } catch (_) {}
    this.restoreFocus();this.hidden = true;
  }

  restoreFocus() {
    if (!this.contains(document.activeElement)) return;
    const target = this.body.closest('article') || this.body;
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  }

  async cartUpdate(event) {
    if (!this.contains(event.target) || event.action !== 'add') return;
    const panel = event.target.closest('[data-float-panel]');
    const status = panel?.querySelector('[data-float-status]');
    const button = panel?.querySelector('button[type="submit"]');
    if (button) button.disabled = true;
    try {
      const result = await event.promise;
      if (status) status.textContent = result?.detail?.didError ? this.dataset.error : this.dataset.added;
    } catch (_) {
      if (status) status.textContent = this.dataset.error;
    } finally {
      if (button) button.disabled = false;
      this.pending = false;
    }
  }

  collisionState() {
    const visible = element => {
      const rect = element.getBoundingClientRect();const style = getComputedStyle(element);
      return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) !== 0;
    };
    const blocked = [...document.querySelectorAll('dialog[open],theme-drawer[open],[data-cotigo-editor-open="true"],shopify-chat[open],.shopify-pc__banner__dialog,#shopify-pc__banner')].some(visible);
    if (blocked) return { blocked: true, bottom: 0 };
    const width = innerWidth <= 600 ? innerWidth - 24 : 340;
    const left = innerWidth <= 600 ? 12 : innerWidth - 24 - width;
    let bottom = 0;
    for (const element of document.querySelectorAll('shopify-chat,iframe[id*="chat" i],iframe[title*="chat" i],#preview-bar-iframe,iframe[src*="preview-bar"],iframe[src*="merchantverse"]')) {
      if (!visible(element)) continue;
      const rect = element.getBoundingClientRect();
      if (element.id === 'PBarNextFrame') {
        bottom = Math.max(bottom, innerWidth <= 600 ? 128 : 76);
        continue;
      }
      if (innerWidth <= 600 && element.matches('iframe[src*="merchantverse"],shopify-chat')) {
        bottom = Math.max(bottom, 104);
        continue;
      }
      if (rect.bottom <= innerHeight * 0.55 || rect.top >= innerHeight || rect.right <= left || rect.left >= left + width) continue;
      if (rect.height > 450 || rect.width > 500 && !element.matches('iframe[src*="preview-bar"],#preview-bar-iframe')) continue;
      bottom = Math.max(bottom, innerHeight - rect.top + 12);
    }
    return { blocked: false, bottom };
  }

  tick() {
    const now = performance.now();
    if (!document.hidden) this.elapsed += now - this.last;
    this.last = now;
    const rect = this.body.getBoundingClientRect();
    const progress = Math.max(0, -rect.top / Math.max(1, rect.height - innerHeight));
    this.dataset.elapsed = String(Math.floor(this.elapsed / 1000));this.dataset.progress = String(Math.round(progress * 100));
    if (!this.dismissed && !document.hidden && this.elapsed >= 10000 && progress >= 0.25) this.armed = true;
    const collision = this.collisionState();
    this.style.setProperty('--float-obstacle-bottom', `${collision.bottom}px`);
    const show = this.armed && !this.dismissed && !collision.blocked;
    if (show && this.hidden) {
      this.dataset.entering = '';this.hidden = false;
      this.panels[this.current].querySelectorAll('img').forEach(image => image.loading = 'eager');
      requestAnimationFrame(() => requestAnimationFrame(() => this.removeAttribute('data-entering')));
    } else if (!show && !this.hidden) {
      this.restoreFocus();this.hidden = true;
    }
  }
}
if (!customElements.get('cotigo-article-float')) customElements.define('cotigo-article-float', CotigoArticleFloat);
